import React from 'react';
import { useTheme } from 'styled-components';
import { IconClose } from '../../icons/close';
import { cn } from '../../../../utils/tailwind';

type ModalHeaderType = {
    children?: React.ReactNode;
    title?: string | React.ReactNode;
    onClose?: () => void;
    locked?: boolean;
    showCloseButton?: boolean;
};

export const ModalHeader: React.FC<ModalHeaderType> = ({
    title,
    children,
    onClose,
    locked = false,
    showCloseButton = true,
}: ModalHeaderType) => {
    const theme = useTheme();

    return (
        <div className="flex flex-col gap-medium px-[2rem] pt-[2rem] pb-[1rem] md:px-[3.2rem] md:pt-[3.2rem] md:pb-[1.6rem]">
            <div className="flex items-center justify-between">
                <div className="text-vlarge leading-[1.2] font-bold text-text">{title}</div>
                {showCloseButton && (
                    <div
                        className={cn(
                            'flex cursor-pointer items-center justify-center [&_i]:h-[2rem] [&_i]:w-[2rem] [&_i]:text-[var(--modal-close-color)] [&_i]:transition-colors hover:[&_i]:text-[var(--modal-close-hover-color)]',
                            'transition-[background-color,color,opacity] duration-200 ease-out motion-reduce:transition-none [&_i]:transition-colors [&_i]:duration-200 [&_i]:ease-out motion-reduce:[&_i]:transition-none',
                            locked && 'select-none [&_i]:text-neutral-white hover:[&_i]:text-neutral-white',
                        )}
                        style={
                            {
                                '--modal-close-color': theme.modal.close.base.color,
                                '--modal-close-hover-color': theme.modal.close.hover.color,
                            } as React.CSSProperties
                        }
                        onClick={onClose}
                    >
                        <IconClose />
                    </div>
                )}
            </div>
            {children || null}
        </div>
    );
};
